/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

export const StyledGeneralMessage = styled.article`
  box-shadow: 0 1px 5px 0 rgb(0 0 0 / 14%);
  display: flex;
  /* align-items: center; */
  & *:nth-child(1) {
    flex: 1 1 auto;
  }
`;
